function min(message, limit, type = String) {
    return (value) => {
        if (value === null || value === undefined || value === '') {
            return;
        }
        const size = type === String || Number.isNaN(value)
            ? String(value).length
            : Number(value);
        if (size < limit) {
            throw new Error(message);
        }
    };
}
export default min;
